export const LOCAL_STORAGE_SURE_API_URL_KEY = 'SURE_API_URL';

export const URL_FROM_STORAGE = localStorage.getItem(
  LOCAL_STORAGE_SURE_API_URL_KEY
);
